import { parseNumberArg, parseStringArg } from '@/utils/string'

import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: 'admin/list',
    name: 'admin-list',
    meta: { title: '管理员列表', componentName: 'AdminList' },
    component: () => import('@/views/pc/account/AdminList.vue'),
    props: true
  },
  {
    path: 'admin/:adminId(\\d+)',
    name: 'admin-info',
    meta: { title: '管理员信息', componentName: 'AdminInfo' },
    component: () => import('@/views/pc/account/AdminInfo.vue'),
    props: (to) => ({ adminId: parseNumberArg(to.params.adminId) })
  },
  {
    path: 'admin/phone',
    redirect: '/me'
  },
  {
    path: 'admin/password',
    redirect: '/me'
  },
  {
    path: 'user/list',
    name: 'user-list',
    meta: { title: '用户列表', componentName: 'UserList' },
    component: () => import('@/views/pc/account/UserList.vue'),
    props: true
  },
  {
    path: 'user/:userId(\\d+)',
    name: 'user-info',
    meta: { title: '用户信息', componentName: 'UserInfo' },
    component: () => import('@/views/pc/account/UserInfo.vue'),
    props: (to) => ({ userId: parseNumberArg(to.params.userId) })
  },
  {
    path: 'provider/list',
    name: 'provider-list',
    meta: { title: '服务商列表', componentName: 'ProviderList' },
    component: () => import('@/views/pc/account/ProviderList.vue'),
    props: true
  },
  {
    path: 'provider/:providerId(\\d+)',
    name: 'provider-info',
    meta: { title: '服务商信息', componentName: 'ProviderInfo' },
    component: () => import('@/views/pc/account/ProviderInfo.vue'),
    props: (to) => ({ providerId: parseNumberArg(to.params.providerId) })
  },
  {
    path: 'provider/:providerId(\\d+)/skill',
    name: 'provider-skill-list',
    meta: { title: '能力列表', componentName: 'SkillList' },
    component: () => import('@/views/pc/account/SkillList.vue'),
    props: (to) => ({ providerId: parseNumberArg(to.params.providerId) })
  },
  {
    path: 'skill/list/:categoryId(\\d+)?',
    name: 'skill-list',
    meta: { title: '茶艺师列表', componentName: 'SkillList' },
    component: () => import('@/views/pc/account/SkillList.vue'),
    props: (to) => ({ categoryId: parseNumberArg(to.params.categoryId) })
  },
  {
    path: 'skill/:skillId(\\d+)',
    name: 'skill-info',
    meta: { title: '能力信息', componentName: 'SkillInfo' },
    component: () => import('@/views/pc/account/SkillInfo.vue'),
    props: (to) => ({
      skillId: parseNumberArg(to.params.skillId),
      categoryId: parseNumberArg(to.query.categoryId),
      providerId: parseNumberArg(to.query.providerId)
    })
  },
  {
    path: 'employee/list',
    name: 'employee-list',
    meta: { title: '员工列表', componentName: 'EmployeeList' },
    component: () => import('@/views/pc/account/EmployeeList.vue'),
    props: true
  },
  {
    path: 'employee/:merchantId(\\d+)/list',
    name: 'merchant-employee-list',
    meta: { title: '员工列表', componentName: 'EmployeeList' },
    component: () => import('@/views/pc/account/EmployeeList.vue'),
    props: (to) => ({ merchantId: parseNumberArg(to.params.merchantId) })
  },
  {
    path: 'employee/:employeeId(\\d+)',
    name: 'employee-info',
    meta: { title: '员工信息', componentName: 'EmployeeInfo' },
    component: () => import('@/views/pc/account/EmployeeInfo.vue'),
    props: (to) => ({
      employeeId: parseNumberArg(to.params.employeeId),
      merchantId: parseNumberArg(to.query.merchantId)
    })
  },
  {
    path: 'album/list/:ownerType',
    name: 'album-list',
    meta: { title: '相册列表', componentName: 'AlbumList' },
    component: () => import('@/views/pc/account/AlbumList.vue'),
    props: (to) => ({
      ownerId: parseNumberArg(to.query.ownerId),
      ownerType: parseStringArg(to.params.ownerType, 'upper')
    })
  },
  {
    path: 'schedule',
    name: 'schedule',
    meta: { title: '排班', componentName: 'ScheduleSetting' },
    component: () => import('@/views/pc/account/ScheduleSetting.vue'),
    props: (to) => ({
      ownerId: parseNumberArg(to.query.ownerId),
      ownerType: parseStringArg(to.query.ownerType, 'upper')
    })
  }
] as RouteRecordRaw[]
